import { useEffect, useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import DataTable from '../DataTable';
import { Input, Select } from '../Input/Input';
import { CODES_WITH_EXCISE } from './constants';
import { GoogleAnalyticsContext } from '../GoogleAnalytics';

const ExciseModal = ({
  items = [],
  show,
  onHide,
  onSave,
  locked,
  disabled,
  commCodeIndex,
  productTypeIndex,
  exciseCodeIndex,
  exciseOptions = [],
}) => {
  const ga = useContext(GoogleAnalyticsContext);
  const [exciseItems, setExciseItems] = useState([]);

  const sendGAEvent = (event) => {
    if (ga.gaInitialized && event) {
      window?.gtag?.('event', event, {
        event_category: 'Excise Modal',
      });
    }
  };

  useEffect(() => {
    if (show) {
      const transformedItems = items.map((item, idx) => ({
        lineNumber: idx + 1,
        commodityCode: locked ? item['HS Code (10)'] : item[commCodeIndex]?.text,
        exciseProductType: locked ? item.exciseProductType : item[productTypeIndex]?.text,
        exciseTaxCode: locked ? item.exciseTaxCode : item[exciseCodeIndex]?.text,
      }));
      const filteredItems = transformedItems.filter((item) => CODES_WITH_EXCISE.includes(item.commodityCode));
      setExciseItems(filteredItems);
    }
  }, [show]);

  const onChange = (lineNumber, value, field) => {
    // Find the tax code belonging to the product type - and set it to the exciseTaxCode field if the product type is changed
    const taxCode = exciseOptions.find((option) => option.productType === value)?.exciseTaxCode || '';
    const newExciseCode = field === 'exciseProductType' && value ? taxCode : '';

    setExciseItems((prev) =>
      prev.map((item) =>
        item.lineNumber === lineNumber ? { ...item, [field]: value, exciseTaxCode: newExciseCode } : item
      )
    );
  };

  return (
    <Modal className="qa-checklist-modal modal-height" animation={false} show={show} size="lg" centered onHide={onHide}>
      <Modal.Header>
        <div className="d-flex w-100 justify-content-between">
          <Modal.Title>Excise</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>
          The below Invoice lines may be applicable to Excise duty.
          <br />
          Please confirm the % alcohol / litre
        </p>

        <DataTable
          dontRefreshPagination
          idKey="id"
          data={exciseItems}
          className="table-striped"
          showAdvnSearch={false}
          sortable={false}
          filterable={false}
        >
          <DataTable.Row style={{ fontSize: '14px' }} noResultsText="No Excise found" />
          <DataTable.Column colKey="lineNumber" header="Line" className="align-middle" />
          <DataTable.Column colKey="commodityCode" header="HS Code" className="align-middle" />
          <DataTable.Column colKey="exciseProductType" header="Product Type" className="align-middle">
            {(item) => (
              <Select
                hideLabel={true}
                data={item.exciseProductType}
                options={exciseOptions.map((option) => ({
                  id: option.productType,
                  data: option.productType,
                }))}
                stopSetDefault={true}
                setData={(value) => {
                  onChange(item.lineNumber, value, 'exciseProductType');
                }}
                disabled={locked || disabled}
              />
            )}
          </DataTable.Column>
          <DataTable.Column colKey="exciseTaxCode" header="Excise Tax Code" className="align-middle">
            {(item) => (
              <Input
                hideLabel={true}
                value={item.exciseTaxCode}
                onChange={(e) => onChange(item.lineNumber, e.target.value, 'exciseTaxCode')}
                disabled
              />
            )}
          </DataTable.Column>
        </DataTable>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          <button className="epo-continue-button small-button" type="button" onClick={onHide}>
            {locked || disabled ? 'Close' : 'Cancel'}
          </button>
          {!locked && !disabled && (
            <button
              className="epo-continue-button small-button blue-button-newload"
              style={{ marginTop: 0 }}
              type="button"
              onClick={() => {
                sendGAEvent('Excise Modal Saved');
                onSave(exciseItems);
                onHide();
              }}
            >
              Save
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ExciseModal;
